import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'app-mrr-up',
  templateUrl: './mrr-up.component.html',
  styleUrls: ['./mrr-up.component.scss']
})
export class MrrUpComponent implements OnInit {
  @Input() valor: number;
  @Input() porcentagem: number;
  @Input() fonte: string;
  constructor() { }

  ngOnInit(): void {
  }

}
